import { ITransclusionReference, ITransclusionReferenceItem } from '@typedream/data';
import { isEqual, isEqualWith } from 'lodash';
import { BLOCK_ELEMENT_KEY } from '../sharedComponents/TextEditor/types';
import contentComparator from '../sharedComponents/TextEditor/utils/contentComparator';
import updateJSON from './updateJSON';

function isTransclusionItemEqual(
  x: ITransclusionReferenceItem,
  y: ITransclusionReferenceItem,
): boolean {
  if (x.name !== y.name || x.transclusion_updated_at !== y.transclusion_updated_at) {
    return false;
  }

  const isXContainingNaN = !isEqual(x, x);
  const isYContainingNaN = !isEqual(y, y);
  if (isXContainingNaN || isYContainingNaN) {
    throw new Error('Transclusion contains NaN');
  }

  const xCleaned = updateJSON({
    id: undefined,
    [BLOCK_ELEMENT_KEY.OPEN_OPTIONS]: undefined,
  })(x as any);

  const yCleaned = updateJSON({
    id: undefined,
    [BLOCK_ELEMENT_KEY.OPEN_OPTIONS]: undefined,
  })(y as any);

  return isEqualWith(xCleaned, yCleaned, contentComparator);
}

export default function isTransclusionEqual(
  a: ITransclusionReference,
  b: ITransclusionReference,
): boolean {
  // compare keys, length must be the same.
  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);

  if (aKeys.length !== bKeys.length) return false;

  // all keys and values must be equal
  return aKeys.every((k) => bKeys.includes(k) && isTransclusionItemEqual(a[k], b[k]));
}
